import { render } from "./ReceptionsComponent.vue?vue&type=template&id=da2bbdfe"
import script from "./ReceptionsComponent.vue?vue&type=script&lang=js"
export * from "./ReceptionsComponent.vue?vue&type=script&lang=js"

import "./ReceptionsComponent.vue?vue&type=style&index=0&id=da2bbdfe&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__